module.exports = __webpack_public_path__ + "static/media/app_only.9b09ea1c.svg";